import ZoneHeading from "./ZoneHeading";

export const Mission = () => {
  return (
    <div className="zone">
      <ZoneHeading id="mission">Our Mission</ZoneHeading>
      <p>
        We partner with founders and family-owned companies in their next stage
        of growth, taking businesses from good to great. We are not just
        flippers, consolidators, or cost-cutters. We want your business and your
        team to survive and thrive for the long run.
      </p>
    </div>
  );
};

export default Mission;